import Vue from 'vue'
import Router from 'vue-router';

import viewRouter from "./modules/view";
import consoleRouter from "./modules/console";//后台路由
import platformRouter from "./modules/platform";//后台路由
import common from "../utils/common";



const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


const routerOptions = {
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'ind',
            redirect: {
                name: 'platform_creator'
            },
        },
        ...viewRouter,
        ...consoleRouter,
        ...platformRouter
    ]
}
const router = new Router(routerOptions)

function normalizeExpires(value) {
    const expires = Number(value) || 0;
    if (!expires) return 0;
    return expires < 10000000000 ? expires * 1000 : expires;
}

function isTokenExpired(expires) {
    const normalizedExpires = normalizeExpires(expires);
    return normalizedExpires > 0 && Date.now() >= normalizedExpires;
}

function parseJwtExpires(token) {
    if (!token) return 0;
    try {
        const payload = token.split('.')[1];
        if (!payload) return 0;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        const exp = JSON.parse(json).exp;
        return Number(exp) || 0;
    } catch (e) {
        return 0;
    }
}

// 导航拦截
router.beforeEach((to, from, next) => {
    document.title = "九马-领先的Ai云直播服务商。提供Ai数字人，虚拟主播场景，无人直播带货，24小时直播间搭建。";
    if (to.meta.auth) {
        let query = to.query;
        let nextQuery = { ...query };
        let tokenInfo = "";
        let expiresInfo = 0;
        let username = localStorage.getItem("username");
        let token = localStorage.getItem("token");
        let expires = localStorage.getItem("expires") || 0;
        if (!token) {
            token = common.getCookie("juima_access_token") || "";
            if (token) {
                localStorage.setItem("token", token);
            }
        }
        if (query.access_token) {
            tokenInfo = query.access_token;
            username = query.username || username || '';
            expiresInfo = query.access_token_exp ? query.access_token_exp * 1 : parseJwtExpires(tokenInfo);
        }
        if (token && isTokenExpired(expires)) {
            token = "";
            expires = 0;
            localStorage.removeItem("token");
            localStorage.removeItem("expires");
        }
        if (tokenInfo && normalizeExpires(expiresInfo) > 0 && normalizeExpires(expires) <= normalizeExpires(expiresInfo)) {
            token = tokenInfo;
            expires = expiresInfo;
            localStorage.setItem("token", tokenInfo);
            localStorage.setItem("expires", expiresInfo);
        }
        if (token && username) {
            localStorage.setItem("username", username);
        }
        if (query.access_token) {
            delete nextQuery.access_token;
            delete nextQuery.access_token_exp;
            delete nextQuery.username;
            if (to.path == '/console/human/meta_create' || to.path == '/console/live') {
                next({
                    path: '/console/platform/creator',
                    query: nextQuery,
                    replace: true
                });
                return;
            }
              if (to.path == '/console/clone_list') {
                next({
                    path: '/console/platform/voice-clone',
                    query: nextQuery,
                    replace: true
                });
                return;
            }
            next({
                path: to.path,
                query: nextQuery,
                replace: true
            });
            return;
        }
        next();
    } else {
        document.title = to.meta.title || '九马直播';
        next();
    }


});


Vue.use(Router)

export default router
